import { useMutation } from '@tanstack/react-query';
import { queryClient } from '~/lib/react-query';
import { hideLoader, showLoader } from '~/common';

interface EventEnrollmentData {
  external_user_ids?: string[];
  academy_event_id: string;
  emails?: string[];
  academy_event_on_demand_content_id?: string;
  academy_event_session_id?: string;
}

interface UseEventEnrollmentProps {
  onSuccess?: () => void;
  onError?: (error: Error) => void;
}

export const useEventEnrollment = ({ onSuccess, onError }: UseEventEnrollmentProps = {}) => {
  const enrollUsersToEvent = async (enrollmentData: EventEnrollmentData) => {
    showLoader();
    const response = await fetch('/academies/api/academy_event_invitations/bulk_create', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'X-CSRF-Token': document.querySelector('meta[name="csrf-token"]')?.getAttribute('content') || '',
      },
      body: JSON.stringify(enrollmentData),
    });

    if (!response.ok) {
      const errorData = await response.json().catch(() => ({}));
      throw new Error(`Event enrollment failed: ${response.status} ${response.statusText}`, { cause: errorData });
    }

    return response.json();
  };

  return useMutation({
    mutationFn: enrollUsersToEvent,
    onSuccess: () => {
      queryClient.invalidateQueries(['team-lead-contacts']);
      queryClient.invalidateQueries(['assignments']);
      onSuccess?.();
    },
    onError: (error: Error) => {
      onError?.(error);
    },
    onSettled() {
      hideLoader();
    },
  });
};
